const CAPITALIZATION_PREFIXES = ['-', "'"];

/**
 * Formats a name token, which is assumed to be a single trimmed word.
 */
function formatNameHelper(token: string): string {
  // First letter is always capitalized.
  let formatted = token[0].toLocaleUpperCase('en-US');

  // For all following letters, capitalize if they are preceded by any of
  // the capitalization prefixes. Otherwise, lowercase.
  for (let i = 1; i < token.length; i += 1) {
    const prefix = token[i - 1];
    if (CAPITALIZATION_PREFIXES.includes(prefix)) {
      formatted += token[i].toLocaleUpperCase('en-US');
    } else {
      formatted += token[i].toLocaleLowerCase('en-US');
    }
  }

  return formatted;
}

export function formatName(name: string): string {
  // Characters should be capitalized if they are preceded by any of the captured characters
  //   - hypen (-), apostrophe ('), or space ( )
  // All other characters should be lowercase.
  const trimmed = name.trim().replace(/\s+/g, ' ');
  const nameTokens = trimmed.split(' ');

  const formattedTokens = nameTokens.map(formatNameHelper);
  return formattedTokens.join(' ');
}
